export const FilterContains = (filter, searchParm, searchValue) => {
  if (searchValue !== "" && searchValue !== undefined) {
    if (filter !== "&$filter=") {
      filter += " and ";
    }
    filter += "contains(" + searchParm + ",'" + searchValue + "')";
  }
  return filter;
};
export const FilterEqual = (filter, searchParm, searchValue) => {
  if (searchValue !== "" && searchValue !== undefined) {
    if (filter !== "&$filter=") {
      filter += " and ";
    }
    filter += " " + searchParm + " eq '" + searchValue + "'";
  }
  return filter;
};

// Filter, Contains With Case-Insensitive Allow
export const FilterContainsInsensitive = (
  filter,
  searchParm,
  searchValue,
  IsAddedAnd = true
) => {
  if (searchValue !== "" && searchValue !== undefined) {
    searchValue = searchValue.trim();
    if (filter !== "&$filter=" && IsAddedAnd === true) {
      filter += " and ";
    }
    filter +=
      "(contains(tolower(" +
      searchParm +
      "),'" +
      searchValue.toLowerCase() +
      "') or contains(toupper(" +
      searchParm +
      "),'" +
      searchValue.toUpperCase() +
      "'))";
  }

  return filter;
};

export const FilterContainsTwoField = (
  filter,
  searchParm1,
  searchParm2,
  searchValue
) => {
  if (searchValue !== "" && searchValue !== undefined) {
    if (filter !== "&$filter=") {
      filter += " and ";
    }
    filter +=
      "(contains(" + searchParm1 + ",'" + searchValue.toUpperCase() + "')";
    filter +=
      "or contains(" + searchParm2 + ",'" + searchValue.toUpperCase() + "'))";
  }
  return filter;
};

export const FilterKeyWord = (filter, searchParm, searchValue, keyWord) => {
  if (searchValue !== "" && searchValue !== undefined) {
    if (filter !== "&$filter=") {
      filter += " and ";
    }
    filter += " " + searchParm + " " + keyWord + " " + searchValue;
  }
  return filter;
};
